// extracted by mini-css-extract-plugin
export var profileDiv = "profile-component-module--profile-div--s8r7H";
export var profileImg = "profile-component-module--profile-img--6ym7a";
export var profileName = "profile-component-module--profile-name--DvQHa";
export var profileJob = "profile-component-module--profile-job--AASjI";